'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var actionState = {};

exports.default = function () {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ws://api.mindself.com:8888';
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;

    var client = void 0;
    function connect() {
      client = new WebSocket(url);
      client.onerror = function (e) {
        return console.log('Connection Error', e);
      };
      client.onopen = function () {};
      client.onclose = function () {
        return setTimeout(connect, 500);
      };
      client.onmessage = function (e) {
        if (typeof e.data !== 'string') return;
        var data = JSON.parse(e.data);
        actionState[data.contentId] = data;
      };
    }
    connect();

    return function (next) {
      return function (action) {
        if (typeof action === 'function') return action(dispatch, getState);
        if (action.type !== 'CALL_MINDSELF_WS_SEND') return next(action);

        var minselfAPIWSSend = action.minselfAPIWSSend,
            types = action.types,
            rest = _objectWithoutProperties(action, ['minselfAPIWSSend', 'types']);

        if (!minselfAPIWSSend) return next(action);

        var _types = _slicedToArray(types, 3),
            REQUEST = _types[0],
            SUCCESS = _types[1],
            FAILURE = _types[2];

        next(_extends({}, rest, { type: REQUEST }));

        var id = Math.random(1).toString().substr(2, 10);
        action.id = id;
        return new Promise(function (resolve, reject) {
          minselfAPIWSSend(client, id);
          var attempt = 20;
          function waiting() {
            if (actionState[id]) {
              resolve(next(_extends({}, rest, { result: actionState[id], type: SUCCESS })));
              delete actionState[id];
            } else {
              attempt--;
              if (attempt < 0) {
                reject(next(_extends({}, rest, { result: actionState[id], type: FAILURE })));
                delete actionState[id];
                return;
              }
              setTimeout(waiting, 1e3);
            }
          }
          waiting();
        });
      };
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/middlewares/websocket.js
// module id = 513
// module chunks = 1